import React from "react";
import { VaultLogoMini } from "@/components/VaultLogo";

const LINKS = [
  { id: "hero", label: "Home" },
  { id: "how-it-works", label: "How It Works" },
  { id: "philosophy", label: "Investment Philosophy" },
  { id: "lrs", label: "The LRS Window" },
  { id: "contact", label: "Contact" },
];

const Footer = () => {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer data-testid="site-footer" className="bg-[#111111] border-t border-[#C9960C]/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
          <div className="flex items-center gap-3">
            <VaultLogoMini size={36} />
            <span className="font-serif-display text-[#C9960C] tracking-[0.2em] uppercase text-base">
              The Global Vault
            </span>
          </div>

          <div className="text-center">
            <p className="italic text-[#F5D485] tracking-[0.35em] uppercase text-xs sm:text-sm">
              Wealth Without Borders
            </p>
          </div>

          <nav className="flex flex-wrap md:justify-end gap-x-6 gap-y-3">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`footer-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-[12px] tracking-[0.18em] uppercase text-[#F5D485]/80 hover:text-[#C9960C] transition-colors cursor-pointer"
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="mt-12 h-px w-full bg-[#C9960C]/20" />

        <div className="mt-8 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between text-[12px] text-[#F8F6F0]/55 leading-relaxed">
          <p className="italic max-w-3xl">
            Strictly Private &amp; Confidential. Investment in global securities involves risk. Past performance is not indicative of future results.
          </p>
          <p>© {new Date().getFullYear()} The Global Vault. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
